import {remCalc} from '_themeUtils'

const pagination = {
    Pagination: {
        baseStyle: () => ({
            wrapper: {
                w: 'full',
                px: {base: '0', lg: 'spacing.4'},
                py: {base: 'spacing.4', md: 'spacing.8'},
                justifyContent: 'center',
                // mt: 'spacing.22',
                gridColumn: '1 / -1',
                sx: {
                    button: {
                        fontSize: remCalc(16),
                    },
                },
            },
            recap: {
                textStyle: 'paragraphSm',
                letterSpacing: remCalc(1),
                fontWeight: 400,
                mb: 'spacing.4',
            },
            searchTerm: {
                fontWeight: 700,
                fontStyle: 'italic',
            },
            skeletonRecap: {
                maxW: remCalc(200),
                h: remCalc(20),
                mx: 'auto',
                w: 'full',
            },
        }),
    },
}

export default pagination
